import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-4 py-28" style={{ background: 'radial-gradient(circle at 50% 30%, rgba(50, 185, 232, 0.08), transparent 24rem)' }}>
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-extrabold mb-4 text-ink">Etwas ist schiefgelaufen</h1>
            <p className="text-ink-soft mb-8 max-w-md mx-auto text-base sm:text-lg leading-relaxed">
              Die Seite konnte nicht geladen werden. Bitte lade neu oder kehre zur Startseite zurück.
            </p>
            <button
              onClick={this.handleReset}
              className="inline-flex items-center justify-center gap-2 min-h-12 px-5 py-3 rounded-card font-bold bg-gradient-to-br from-signal to-[#63d0f3] text-ink shadow-button hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              Zur Startseite
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
